import React from 'react';
import { CtaGlyph } from '../deck/CtaGlyph';
import { actionCtas, snakCtaLinks } from '../../data/deck';

/**
 * The four professional next steps, shown at the foot of every
 * Solventum-styled (dark) screen in the Snak.
 */
export function SnakCtaGrid() {
  return <nav aria-label="Next steps" className="mt-6 border-t border-white/[0.12] pt-5" data-id="element-479" data-mp="1k15tmcydiw52">
      <ul className="grid grid-cols-2 gap-2.5" data-id="element-480" data-mp="1f2bdjirsjlon">
        {actionCtas.map(cta => <li key={cta.icon} data-id="element-481" data-mp="raw7beww8k84">
            <a href={snakCtaLinks[cta.icon]} target="_blank" rel="noopener noreferrer" className="flex h-full min-h-[52px] items-center gap-2.5 rounded-[12px] border border-white/60 px-3 py-2.5 font-body text-[12.5px] leading-tight text-white transition-colors hover:border-white hover:bg-white/[0.06] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-482" data-mp="mbknty5570mu">
              <span className="shrink-0" data-id="element-483" data-mp="27nuhrgdz7ku4">
                <CtaGlyph icon={cta.icon} size={17} data-id="element-484" data-mp="27r0972a2uyt0" />
              </span>
              {cta.short}
            </a>
          </li>)}
      </ul>
    </nav>;
}